/**
 * Ledger tax-settings endpoints (bos-api, BOS-90).
 *
 * Paths are relative to the axios client's base, which already ends in
 * `/api/v1` — so `/ledger/tax-settings/current` reaches
 * `…/api/v1/ledger/tax-settings/current`.
 */

/** Ids and dates are server-shaped, but escaping keeps the path well-formed. */
const seg = (value: string): string => encodeURIComponent(value);

export const SettingsEndpoints = {
    /**
     * GET — the rate set in force **today**. 404 `NO_RATE_SET_IN_FORCE` when
     * nothing is in force, which happens in two very different situations:
     * no set has ever been recorded (onboarding), or every recorded set is
     * future-dated (scheduled). The history endpoint distinguishes them.
     */
    current: () => '/ledger/tax-settings/current',

    /**
     * GET — the set in force on a given `yyyy-MM-dd`. 400
     * `NO_RATES_IN_FORCE_ON_DATE` when the date precedes the earliest set.
     */
    onDate: (date: string) => `/ledger/tax-settings/on/${seg(date)}`,

    /** GET — the full history, newest first, for audit. */
    history: () => '/ledger/tax-settings',

    /**
     * POST — record a change. 201 on first create, 200 on an idempotent
     * replay of the same id with identical content.
     */
    recordChange: () => '/ledger/tax-settings',

    /** GET — one recorded set by id. */
    byId: (id: string) => `/ledger/tax-settings/${seg(id)}`,
};
